import { Button, IconButton, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import Iconify from "../../../minimals/components/iconify";
import { formatUTCDateWithLocalTime } from "../../../utils";
import BulletinRowData from "../BulletinRowData";
import { createMatchResolutionRequestColumn } from "../MatchResolution/MatchResolutionRequestColumn";
import { createRemovalRequestColumn } from "../RemovalRequest/RemovalRequestColumn";
import { BlacklistEntityType, CompanyRecord, RemovalRequest } from "../types";

export const companyRecordColumns = (refreshData: () => Promise<void>, onEdit?: (entityId: number) => void): MRT_ColumnDef<CompanyRecord>[] => [
  ...(onEdit ? [{
    id: "edit",
    header: "",
    size: 80,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }: any) => (
      <IconButton onClick={() => onEdit(row.original.id)}>
       <Iconify icon={"eva:edit-fill"} />
     </IconButton>
    ),
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } }
  }] as MRT_ColumnDef<CompanyRecord>[] : []),
  {
    accessorKey: "id",
    header: "ID",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  createRemovalRequestColumn<CompanyRecord>(refreshData, BlacklistEntityType.Company),
  createMatchResolutionRequestColumn<CompanyRecord>(refreshData, BlacklistEntityType.Company),
  {
    accessorKey: "createdByUser.fullName",
    header: "Created By",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "createdDate",
    header: "Created Date",
    size: 50,
    accessorFn: (row) => (row.createdDate ? formatUTCDateWithLocalTime(row.createdDate) : null),
    Cell: ({ renderedCellValue }) => <Typography variant="subtitle2">{renderedCellValue}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "name",
    header: "Name",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "taxID",
    header: "Tax ID",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "lookupCode",
    header: "Lookup Code",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "companyType.name",
    header: "Type",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "bulletins",
    header: "Bulletins",
    size: 900,
    Cell: ({ row }) => {
      const bulletins = row.original.bulletins;
      if (!bulletins || bulletins.length === 0) return <span>No bulletins</span>;
      return (
        <div style={{ maxHeight: "150px", overflowY: "auto" }}>
          {bulletins.map((bulletinRecord, index) => (
            <BulletinRowData key={index} bulletin={bulletinRecord.bulletin} />
          ))}
        </div>
      );
    },
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "notes",
    header: "Notes",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  }
];
